import {isBrandPortal} from '@netx/core-cms-next/utils/isBrandPortal';
import {SearchType} from './rules/constants';
import type {SearchRules} from './rules/types';
import {searchRulesContainType} from './utils';

export const canSaveSearchRules = (searchRules: SearchRules) => {
	return (
		!isBrandPortal() &&
		![
			SearchType.CART,
			SearchType.SAVED_SEARCH,
			SearchType.VISUAL,
			SearchType.AI,
		].some((type) => searchRulesContainType(searchRules, type))
	);
};
